<template>
  <v-container class="pa-0 ma-0 container-special-infoCotacao">
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          COTAÇÃO
          <p>{{ formatarNumeroCotacao(id) }}</p>
        </v-flex>
        <v-flex row wrap>
          APÓLICE
          <p>{{ formatarNumeroApolice(apoliceNumeroProposta) }}</p>
        </v-flex>
        <v-flex>
          CNPJ
          <p>{{ formatarCnpj(proponenteCnpj) }}</p>
        </v-flex>
        <v-flex
          >RAZÃO SOCIAL
          <p>{{ proponenteRazaoSocial }}</p>
        </v-flex>
        <v-flex
          >ÍTENS
          <p>{{ quantidadeItens }}</p>
        </v-flex>
        <v-flex>
          VIGÊNCIA
          <p>{{ formatarData(dateInicio) }}</p>
        </v-flex>
        <v-flex>
          <br />
          <p>{{ formatarData(dateFim) }}</p>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container  style="max-width: 100%!important" class="ma-0 container-special-infoCotacao pa-0 background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!selected.length"
            color="primary"
            round
            dark
            @click="dialog = true"
            :disabled="camposDisabled"
            >Adicionar Ítem</v-btn
          >

          <v-btn
            @click="filtrarErros = !filtrarErros"
            :class="filtrarErros ? 'activeError' : 'error'"
            v-if="numeroErros && !selected.length"
            round
            ><v-icon class="mr-1">error</v-icon
            >{{ `${numeroErros} ${numeroErros === 1 ? "Erro" : "Erros"}` }}
          </v-btn>

          <v-btn
            v-if="mostrarBotaoReavaliar"
            @click="reavaliarItem(selected)"
            color="primary"
            round
          >
            Reavaliar Ítem
          </v-btn>
          <v-btn
            @click="deletarItens"
            v-if="selected.length >= 1"
            color="error"
            round
          >
            {{
              selected.length === 1 ? "Excluir Ítem" : "Excluir Ítens"
            }}</v-btn
          >
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :select-all="!camposDisabled"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                  :disabled="camposDisabled"
                ></v-checkbox>
              </td>
              <td class="pa-4 themeGrey--text">
                {{ formatarNumeroItem(props.item.item) }}
              </td>
              <td class="pa-0 item-faltante">
                <v-tooltip
                  v-if="props.item.erro"
                  right
                  color="error"
                  max-width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <span class="error--text" v-on="on">⬤</span>
                  </template>
                  <span
                    >Não foi possivel avaliar este item devido a um ou mais
                    erros nos dados informados. Consulte a FIPE, corrija o(s)
                    erro(s) direto na linha e clique em "Reavaliar Item" para
                    reprocessar os dados.</span
                  >
                </v-tooltip>
              </td>
              <td class="">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.placa"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.placa
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.placa"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>

                <span class="themeGrey--text" v-else>{{
                  props.item.placa
                }}</span>
              </td>
              <td class="">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.chassi"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.chassi
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.chassi"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.chassi
                }}</span>
              </td>
              <td class="">
                <template v-if="!props.item.fipe || props.item.erro">
                  <v-btn
                    @click="
                      (selecionarModelo = props.item), (dialogFipe = true)
                    "
                    class="error"
                    round
                  >
                    Selecionar
                  </v-btn>
                </template>
                <template v-else>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.fipe"
                    lazy
                    large
                    persistent
                    @save="saveErro(props.item)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    {{ props.item.fipe }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="props.item.fipe"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.fipe
                  }}</span>
                </template>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.marca"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.marca
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.marca"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.marca }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.modelo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.modelo
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.modelo"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.modelo }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoVeiculo"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(props.item.tipoVeiculo, campos.tipoVeiculoList)
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoVeiculoList"
                      v-model="props.item.tipoVeiculo.id"
                      item-text="titulo"
                      item-value="id"
                      label="Editar"
                      :rules="regras.notNull"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.tipoVeiculo, campos.tipoVeiculoList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.catVeiculo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].catVeiculo.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.catVeiculo, campos.catVeiculoList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.catVeiculoList"
                      v-model="props.item.catVeiculo"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.catVeiculo, campos.catVeiculoList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.anoFab"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.anoFab
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.anoFab"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.anoFab }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.anoMod"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.anoMod
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.anoMod"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.anoMod }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.ufPernoite"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].ufPernoite.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.ufPernoite, campos.ufPernoiteList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.ufPernoiteList"
                      v-model="props.item.ufPernoite"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.ufPernoite, campos.ufPernoiteList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.usoDoVeiculo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].usoDoVeiculo.erro,
                    }"
                    >{{
                      buscarTitulo(
                        props.item.usoDoVeiculo,
                        campos.usoDoVeiculoList
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.usoDoVeiculoList"
                      v-model="props.item.usoDoVeiculo"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(
                      props.item.usoDoVeiculo,
                      campos.usoDoVeiculoList
                    )
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.propriedadeRegistroDoCrlv"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa:
                        erros[props.item.item].propriedadeRegistroDoCrlv.erro,
                    }"
                    >{{
                      buscarTitulo(
                        props.item.propriedadeRegistroDoCrlv,
                        campos.propriedadeRegistroDoCrlvList
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.propriedadeRegistroDoCrlvList"
                      v-model="props.item.propriedadeRegistroDoCrlv"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(
                      props.item.propriedadeRegistroDoCrlv,
                      campos.propriedadeRegistroDoCrlvList
                    )
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                {{ props.item.proprietario }}
              </td>
              <td class="themeGrey--text">
                {{ props.item.cpfCnpj }}
              </td>
              <td class="themeGrey--text">
                {{ traduzValor(props.item.chassiRemarcado) }}
              </td>
              <td class="themeGrey--text">
                {{ traduzValor(props.item.zeroKm) }}
              </td>

              <td class="text-xs-center themeGrey--text">
                {{ formatarData(props.item.saidaDaConcessionaria) }}
              </td>
              <td class="themeGrey--text">
                {{Object.keys(chassiQtdPassageiros).length !== 0 ? chassiQtdPassageiros[props.item.chassi] : props.item.quantPassageiro }}
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.codigoSistemaRastreamento"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].codigoSistemaRastreamento.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.codigoSistemaRastreamento, campos.codigoSistemaRastreamentoList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.codigoSistemaRastreamentoList"
                      v-model="props.item.codigoSistemaRastreamento"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.codigoSistemaRastreamento, campos.codigoSistemaRastreamentoList)
                  }}
                </span>
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-divider></v-divider>
      <v-layout row class="d-flex pa-3" style="justify-content: space-between;background-color: #f2f2f2">
        <v-flex md2>
          <v-btn  style="width: 100%" color="primary" @click="voltar" flat> Voltar </v-btn>
        </v-flex>
        <v-flex md2 >
          <v-btn
            class="primary"
            style="width: 86%"
            @click="
              numeroErros > 0 || !validaColunas()
                ? (dialogConfirmacao = true)
                : proximo()
            "

          >
            Próximo
          </v-btn>
        </v-flex>
      </v-layout>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogAvaliando" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">A ALIANDO ITENS</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span>
                      Por favor, aguarde o processamento. Isso pode levar alguns
                      minutos
                    </span>
                  </v-flex>
                  <v-flex align-center d-flex xs12>
                    <v-progress-linear
                      heigth="2px"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogAvaliando = false"
                >CANCELAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogConfirmacao" max-width="700px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">ATENÇÃO</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12 sm8>
                    <span class="text-permanecer">
                      Existem ítens com erros que ainda não foram corrigidos.
                      <br />
                      Tem certeza de que deseja ir para a próxima etapa sem
                      corrigi-los? <br />
                      Os ítens com erros não serão incluídos na apólice.
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="proximo">
                Ignorar os Erros
              </v-btn>

              <v-btn
                class="button-permanecer"
                flat
                @click="dialogConfirmacao = false"
                >Permanecer nesta etapa
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" hide-overlay fullscreen>
          <AdicionarItemModalCorretorReserva
            v-if="dialog"
            @add="dadosPlanilha.push($event), (dialog = false)"
            :item="proximoIndice"
            :dialog="dialog"
            @fechar="dialog = false"
            :campos="campos"
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialogFipe"
          hide-overlay
          persistent
          max-width="600px"
        >
          <TabelaFipeModalCorretorReserva
            v-if="selecionarModelo"
            :chassi="selecionarModelo.chassi"
            :placa="selecionarModelo.placa"
            @fechar="dialogFipe = false"
            @salvar="preencherDadosVeiculo"
          />
        </v-dialog>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import AdicionarItemModalCorretorReserva from "./AdicionarItemModalCorretorReserva";
import TabelaFipeModalCorretorReserva from "./TabelaFipeModalCorretorReserva";
import { adicionarId } from "@/helpers/url-helper.js";

export default {
  name: "ModalGridVeiculos",
  components: {
    AdicionarItemModalCorretorReserva,
    TabelaFipeModalCorretorReserva,
  },
  props: {
    visualizarVeiculos: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      filtrarErros: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      dialogFipe: false,
      pagination: {
        sortBy: "name",
      },
      selected: [],
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      campos: {
        listaEstados: [],
        tipoVeiculoList: [],
        catVeiculoList: [],
        ufPernoiteList: [],
        usoDoVeiculoList: [],
        propriedadeRegistroDoCrlvList: [],
        diasGarantZeroKmList: [],
        codigoSistemaRastreamentoList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`,
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro",
          },
          {
            id: false,
            titulo: "Sem Sinistro",
          },
        ],
      },
      resultados: {
        totalPremio: null,
      },
      headers: [
        { text: "ITEM", value: "item" },
        { text: "", value: "", notSortable: true, class: "pa-0" },
        {
          text: "PLACA",
          align: "left",
          value: "placa",
        },
        { text: "CHASSI", value: "chassi" },
        { text: "FIPE", value: "fipe", style: "width: 100px" },
        { text: "MARCA", value: "marca" },
        { text: "MODELO ", value: "modelo" },
        { text: "TIPO VEÍCULO", value: "tipoVeiculo" },
        { text: "CAT. VEÍCULO", value: "catVeiculo" },
        { text: "ANO FAB.", value: "anoFab" },
        { text: "ANO MOD.", value: "anoMod" },
        { text: "UF PERNOITE", value: "ufPernoite" },
        { text: "USO DO VEÍCULO", value: "usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
          value: "propriedadeRegistroDoCrlv",
        },
        { text: "PROPRIETÁRIO", value: "proprietario" },
        { text: "CPF/CNPJ", value: "cpfCnpj" },
        { text: "CHASSI REMARCADO", value: "chassiRemarcado" },
        { text: "ZERO KM", value: "zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA", value: "saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS", value: "quantPassageiros" },
        { text: "DISPOSITIVO DE SEGURANÇA", value: "codigoSistemaRastreamento"},
      ],
      dadosPlanilha: [],
      idApolice: null,
      selecionarModelo: null,
      chassis: [],
      chassiQtdPassageiros: {}
    };
  },
  computed: {
    ...mapState("formCorretorReserva", [
      "apoliceNumeroProposta",
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
      "dateInicio",
      "dateFim",
      "totalPremio",
      "idPropostaStatus",
    ]),

    quantidadeItens() {
      return this.$store.getters["formCorretorReserva/quantidadeItem"];
    },

    camposDisabled() {
      return this.visualizarVeiculos == true;
    },

    mostrarBotaoReavaliar() {
      if (this.selected.length !== 1) {
        return false;
      }
      return !!this.erroPlanilha[this.selected[0].item];
    },
    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter((value) => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },
    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },
    erros() {
      const validar = (ativo, temErro) => {
        if (!ativo) {
          return { ativo: false };
        }
        return {
          ativo: true,
          erro: temErro(),
        };
      };
      return this.dadosPlanilha.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.item]: {
            catVeiculo: validar(
              true,
              () => !cur.catVeiculo || typeof cur.catVeiculo.id !== "number"
            ),

            ufPernoite: validar(
              true,
              () => !cur.ufPernoite || typeof cur.ufPernoite.id !== "number"
            ),

            usoDoVeiculo: validar(
              true,
              () => !cur.usoDoVeiculo || typeof cur.usoDoVeiculo.id !== "number"
            ),

            codigoSistemaRastreamento: validar(
              true,
              () => !cur.codigoSistemaRastreamento || typeof cur.codigoSistemaRastreamento.id !== "number"
            ),

            propriedadeRegistroDoCrlv: validar(
              true,
              () =>
                !cur.propriedadeRegistroDoCrlv ||
                typeof cur.propriedadeRegistroDoCrlv.id !== "number"
            ),
            fipe: {
              ativo: !(cur.catVeiculo && [6].includes(cur.catVeiculo.id)),
            }

          },
        }),
        {}
      );
    },
  },
  mounted() {

    this.dadosPlanilha = this.$store.getters["formCorretorReserva/cloneConteudoPlanilha"];
      for(var chassi of this.dadosPlanilha){
        this.chassis.push(chassi.chassi)
      }
    this.buscaOpcoes();
    this.buscarNumPassageiro(this.chassis);
  },
  methods: {
    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        ),
      };
    },

    async buscarNumPassageiro(chassis){
      const chassiModel = {
        chassis: chassis
      }
      var response = await axios.post(
        `${process.env.URL_APOLICEMS}/v1/buscarNumeroPassageiro/`,chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      for(var agregado of response.data){
        this.chassiQtdPassageiros[agregado.nrChassi] = agregado.nrQtdPax
        for(var planilha of this.errosFiltrados){
          if(planilha.chassi === agregado.nrChassi){
          planilha.quantPassageiro = agregado.nrQtdPax
          }
        }

      }

    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },
    formatarNumeroItem(item) {
      return typeof item === "number" ? `000000${item}`.slice(-6) : "----";
    },

    async reavaliarItem(item) {
      this.dialogAvaliando = true;
      try {
        const response = await axios.post(
          `${process.env.URL_PLANILHAMS}/v1/revalidarCamposPlanilha`,
          item,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        );

        response.data.forEach((e) => {
          if (e.erro) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Dados inválidos.";
            return;
          }
          if (
            e.item in this.erroPlanilha &&
            e.erro !== this.erroPlanilha[e.item]
          ) {
            for (let i = 0; i < this.dadosPlanilha.length; i++) {
              if (this.dadosPlanilha[i].item === e.item) {
                this.dadosPlanilha[i].erro = e.erro;
                this.snack = true;
                this.snackColor = "success";
                this.snackText = "Dados validados com sucesso!";
                break;
              }
            }
          }
        });
      } catch (error) {
        return error;
      } finally {
        this.dialogAvaliando = false;
      }
    },

    buscarTitulo(entity, list) {
      if (entity) {
        const campo = list.find(
          (item) => item === entity.id || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    deletarItens() {
      const selecionados = this.selected.map((e) => e.item);
      this.dadosPlanilha = this.dadosPlanilha.filter(
        (e) => !selecionados.includes(e.item)
      );
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },
    close() {
      console.log("Dialog closed");
    },
    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "codigoSistemaRastreamentoList",
          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    voltar: function () {
      this.$emit('voltar');
    },
    proximo() {
      const dadosAtualizados = {
        dados: this.dadosPlanilha,
      };

      /* Lógica para verificar se há chassi duplicado */
      this.chassis.length = 0;

      for(var chassi of dadosAtualizados.dados){
        this.chassis.push(chassi.chassi)
      }

      const chassisRepetidos = this.chassis.filter((e, i, a) => a.indexOf(e) !== i);

      if (chassisRepetidos.length > 0) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Erro no chassi: ${chassisRepetidos[0]}. Possui um ou mais itens com o mesmo chassi.`;
        return;
      }
      /* -------------------------------------------- */

      /* Verifica se o campo Modelo tem mais de 65 caracteres */
      for (var item of dadosAtualizados.dados) {
        if (item.modelo.length > 65) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `[Erro no item ${item.item}] O campo 'Modelo' não pode ultrapassar os 65 caracteres.`;
        return;
        }
      }
      /* -------------------------------------------- */

      this.$store.commit("formCorretorReserva/setConteudoPlanilha", dadosAtualizados);
      this.$emit('proximo');
    },

    comparador(itemLista, item) {
      if (item && item.id) {
        return item.id === itemLista.id;
      }
      return false;
    },

    formatarNumeroCotacao(item) {
      if (item != null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    },
    formatarNumeroApolice(item) {
      if (item != null) {
        return item;
      }
    },

    async preencherDadosVeiculo(veiculoSelecionado, infoVeiculo) {
      if (veiculoSelecionado && veiculoSelecionado.codigoFipe) {
        this.selecionarModelo.fipe = veiculoSelecionado.codigoFipe;
        this.selecionarModelo.modelo = veiculoSelecionado.modelo;
        this.selecionarModelo.anoMod = veiculoSelecionado.anoModelo;
        this.selecionarModelo.marca = veiculoSelecionado.marca;
        this.selecionarModelo.tipoVeiculo = veiculoSelecionado.tipoVeiculo;
        this.selecionarModelo.chassi = infoVeiculo.chassi;
        this.selecionarModelo.placa = infoVeiculo.placa;
        await this.reavaliarItem([this.selecionarModelo]);
        this.selecionarModelo = null;
        this.dialogFipe = false;
      }
    },
  },
};
</script>

<style>
.background {
  background-color: white;
}

.table-width > div > div > table {
  width: 3000px;
}

.item-color > div > a {
  color: #757575 !important;
}

.activeError {
  border: 1px solid red;
  color: red !important;
}

.button-permanecer {
  background: #00456e;
  color: white !important;
}

.text-permanecer {
  font-weight: bold;
  color: #757575 !important;
}
.errorTaxa {
  color: red !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalGridVeiculos.vue